import { err } from ".";

/**
 * value must be like "60m", "2h" etc.
 */
export function convertToSeconds(s: string): number {
    if (!s) {
        return 0;
    }

    const groups = s.match(/(\d+)([dhms]?)/);

    if (!groups) {
        err(`Invalid time string: ${s}`);
        return 0;
    }

    const number = parseInt(groups[1]);
    const unit = groups[2];

    switch (unit) {
        case "d":
            return number * 24 * 60 * 60;
        case "h":
            return number * 60 * 60;
        case "m":
            return number * 60;
        case "s":
            return number;
        default:
            // seconds (no unit)
            return number;
    }
}
